export const stringToSeconds = (delay: string) => {
  const [number, unit] = delay.split(' ');
  if (unit === 'hour' || unit === 'hours') {
    return Number(number) * 60 * 60;
  }
  if (unit === 'day' || unit === 'days') {
    return Number(number) * 60 * 60 * 24;
  }
  return 0;
};
